export interface IWebViewEvent {
  type: EWebViewEvents;
  status?: 'SUCCESS' | 'ERROR';
  payload: {
    id: string;
    url?: string;
    meta?: boolean;
    meetName?: string;
    code?: string;
    message?: string;
    fileUrl?: string;
    fileName?: string;
    mimeType?: string;
    fileSize?: number;
    isMicEnabled?: boolean;
    isCameraEnabled?: boolean;
    title?: string;
    extraTitle?: string;
    text?: string;
    status?: boolean;
  };
}

export enum EWebViewEvents {
  SHARE_META = 'share/meta',
  PAGE_FINISHED = 'pageConfig/v1/PAGE_FINISHED',
  MEETING_ENDED = 'meet/v1/MEETING_ENDED',
  SHARE_TEXT = 'share/v1/SHARE_TEXT',
  START_MEET = 'meet/v1/START_MEET',
  MINIMIZABLE_TOOLBAR = 'pageConfig/v1/MINIMIZABLE_TOOLBAR',
  UPDATE_TOOLBAR = 'pageConfig/v1/UPDATE_TOOLBAR',
  CLOSE = 'navigate/v1/CLOSE',
  WEB_SHEET_OPENED = 'pageConfig/v1/WEB_SHEET_OPENED',
  WEB_SHEET_DISMISSED = 'pageConfig/v1/WEB_SHEET_DISMISSED',
  SERVER_ERROR = 'errorHandler/v1/SERVER_ERROR',
  MUTE_MIC = 'pip/v1/MUTE_MIC',
  UNMUTE_MIC = 'pip/v1/UNMUTE_MIC',
  VIDEO_ON = 'pip/v1/VIDEO_ON',
  VIDEO_OFF = 'pip/v1/VIDEO_OFF',
  ENTER_PIP = 'pip/v1/ENTER_PIP',
  MIC_AND_CAMEAR_STATES = 'pip/v1/MIC_AND_CAMEAR_STATES',
  HIDE_TOOLBAR = 'pageConfig/v1/HIDE_TOOLBAR',
  SHOW_TOOLBAR = 'pageConfig/v1/SHOW_TOOLBAR',
  MEETING_STARTED = 'meet/v1/MEETING_STARTED',
  DOWNLOAD_FILE = 'attachments/v1/DOWNLOAD_FILE',
  NAVIGATE_TO = 'navigate/v1/NAVIGATE_TO',
  IS_ATTENDEE = 'webinar/v1/ATTENDEE',
}
